<ng-container>
    <h1 class="fs-24 text-championPurple mb-3 mb-lg-4">Edit assumptions</h1>
    <form [formGroup]="assumptionForm">
        <section *ngIf="source == 'edf'" aria-label="electricity-rate-config" class="mb-4">
            <div class="row">
                <div class="col-12">
                    <h3 class="fs-18 fw600 text-bodyGrey mb-3">Electricity Rate Configuration</h3>
                </div>
            </div>

            <!-- Rate Structure Selection -->
            <div class="row mb-2">
                <div class="col-12">
                    <label class="form-label fs-14 mb-2">RATE STRUCTURE</label>
                    <div class="rate-structure">
                        <label class="rate-option">
                            <input type="radio" name="elecRateTypeMain" value="single" 
                                formControlName="elecRateTypeMain" />
                            <div class="option-text">
                                <span>Single Rate</span>
                                <small>Flat rate all day</small>
                            </div>
                        </label>
                        <label class="rate-option">
                            <input type="radio" name="elecRateTypeMain" value="multi" 
                                formControlName="elecRateTypeMain" />
                            <div class="option-text">
                                <span>Multi-Rate</span>
                                <small>Day/Night, 2 or 3 Rate</small>
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <!-- Multi-Rate Type Selection -->
            <div class="row mb-4" *ngIf="assumptionForm.get('elecRateTypeMain')?.value === 'multi'">
                <div class="col-12">
                    <label class="form-label fs-14 mb-3">MULTI-RATE TYPE</label>
                    <div class="multi-rate-type row">
                        <div class="col-lg-6 col-md-12">
                        <label class="rate-type-option">
                            <input type="radio" name="elecRateTypeMulti" value="dayNight" 
                                formControlName="elecRateTypeMulti" />
                            <div class="option-content">
                                <span>Day-Night</span>
                                <small>Specify Day Rate and Night Rate with timings for each</small>
                            </div>
                        </label>
                        </div>
                        <div class="col-lg-6 col-md-12">
                        <label class="rate-type-option">
                            <input type="radio" name="elecRateTypeMulti" value="threeRate" 
                                formControlName="elecRateTypeMulti" />
                            <div class="option-content">
                                <span>Three Rate - Evening Weekend</span>
                                <small>Weekday Rate, Evening/Weekend Rate, and Night Rate with timings</small>
                            </div>
                        </label>
                        </div>
                        <div class="col-lg-6 col-md-12">
                        <label class="rate-type-option">
                            <input type="radio" name="elecRateTypeMulti" value="twoRate" 
                                formControlName="elecRateTypeMulti" />
                            <div class="option-content">
                                <span>Two Rate - Evening Weekend</span>
                                <small>Weekday Rate, Evening/Weekend/Night Rate with timings</small>
                            </div>
                        </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Single Rate Configuration -->
            <ng-container *ngIf="assumptionForm.get('elecRateTypeMain')?.value === 'single'">
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="form-label fs-14 text-muted">FLAT RATE</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="unitRate" class="form-label fs-15 mb-1">Unit Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="unitRate" 
                                    placeholder="0" formControlName="unitRate" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecStandingCharge" class="form-label fs-15 mb-1">Standing Charge</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecStandingCharge" 
                                    placeholder="0" formControlName="elecStandingCharge" step="0.01" />
                                <span class="input-group-text bg-white">p/day</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Day-Night Rate Configuration -->
            <ng-container *ngIf="assumptionForm.get('elecRateTypeMain')?.value === 'multi' && assumptionForm.get('elecRateTypeMulti')?.value === 'dayNight'">
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="form-label fs-14 text-muted">DAY-NIGHT RATES</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 mb-4">
                        <div class="form-group">
                            <label for="elecDayRate" class="form-label fs-15 mb-1">Day Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecDayRate" 
                                    placeholder="0" formControlName="elecDayRate" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="form-group">
                            <label for="elecNightRate" class="form-label fs-15 mb-1">Night Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecNightRate" 
                                    placeholder="0" formControlName="elecNightRate" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="form-group">
                            <label for="elecStandingChargeDayNight" class="form-label fs-15 mb-1">Standing Charge</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecStandingChargeDayNight" 
                                    placeholder="0" formControlName="elecStandingChargeDayNight" step="0.01" />
                                <span class="input-group-text bg-white">p/day</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecDayStartTime" class="form-label fs-15 mb-1">Day Start Time</label>
                            <ngb-timepicker formControlName="elecDayStartTime" [spinners]="false"></ngb-timepicker>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecDayEndTime" class="form-label fs-15 mb-1">Day End Time (Night Start)</label>
                            <ngb-timepicker formControlName="elecDayEndTime" [spinners]="false"></ngb-timepicker>
                        </div>
                    </div>
                </div>
                <div class="coverage-visualization">
                    <div class="coverage-header">
                        <span class="coverage-badge">☑ Coverage: 100%</span>
                    </div>
                    <div class="coverage-boxes">
                        <div class="coverage-box day-color">
                            <div class="time-range">Day ({{ formatTime(assumptionForm.get('elecDayStartTime')?.value) }} - {{ formatTime(assumptionForm.get('elecDayEndTime')?.value) }})</div>
                            <div class="rate">{{ assumptionForm.get('elecDayRate')?.value || '-' }}p/kWh</div>
                        </div>
                        <div class="coverage-box night-color">
                            <div class="time-range">Night ({{ formatTime(assumptionForm.get('elecDayEndTime')?.value) }} - {{ formatTime(assumptionForm.get('elecDayStartTime')?.value) }})</div>
                            <div class="rate">{{ assumptionForm.get('elecNightRate')?.value || '-' }}p/kWh</div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Three-Rate Configuration -->
            <ng-container *ngIf="assumptionForm.get('elecRateTypeMain')?.value === 'multi' && assumptionForm.get('elecRateTypeMulti')?.value === 'threeRate'">
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="form-label fs-14 text-muted">THREE RATE - EVENING/WEEKEND</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 mb-4">
                        <div class="form-group">
                            <label for="elecWeekdayRate" class="form-label fs-15 mb-1">Weekday Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecWeekdayRate" 
                                    placeholder="0" formControlName="elecWeekdayRate" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="form-group">
                            <label for="elecEveningRate" class="form-label fs-15 mb-1">Evening/Weekend Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecEveningRate" 
                                    placeholder="0" formControlName="elecEveningRate" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="form-group">
                            <label for="elecNightRateThree" class="form-label fs-15 mb-1">Night Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecNightRateThree" 
                                    placeholder="0" formControlName="elecNightRateThree" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="form-group">
                            <label for="elecStandingChargeThreeRate" class="form-label fs-15 mb-1">Standing Charge</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecStandingChargeThreeRate" 
                                    placeholder="0" formControlName="elecStandingChargeThreeRate" step="0.01" />
                                <span class="input-group-text bg-white">p/day</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecWeekdayStart" class="form-label fs-15 mb-1">Weekday Period Start</label>
                            <ngb-timepicker formControlName="elecWeekdayStart" [spinners]="false"></ngb-timepicker>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecWeekdayEnd" class="form-label fs-15 mb-1">Weekday Period End</label>
                            <ngb-timepicker formControlName="elecWeekdayEnd" [spinners]="false"></ngb-timepicker>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecEveningStart" class="form-label fs-15 mb-1">Evening Period Start</label>
                            <ngb-timepicker formControlName="elecEveningStart" [spinners]="false"></ngb-timepicker>
                            <small class="text-danger" *ngIf="assumptionForm.get('elecEveningStart')?.hasError('notAfternoonEvening')">Evening period must be afternoon/evening time (12:00 or later)</small>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecEveningEnd" class="form-label fs-15 mb-1">Evening Period End (Night Start)</label>
                            <ngb-timepicker formControlName="elecEveningEnd" [spinners]="false"></ngb-timepicker>
                            <small class="text-danger" *ngIf="assumptionForm.get('elecEveningEnd')?.hasError('notAfternoonEvening')">Evening period must be afternoon/evening time (12:00 or later)</small>
                        </div>
                    </div>
                </div>
                <div class="coverage-visualization" [ngClass]="{'coverage-warning': threeRateCoverage.percentage < 100 || threeRateCoverage.overlapMinutes > 0}">
                    <div class="coverage-header">
                        <span class="coverage-badge" [ngClass]="{'text-success': threeRateCoverage.percentage === 100 && threeRateCoverage.overlapMinutes === 0, 'text-danger': threeRateCoverage.percentage < 100 || threeRateCoverage.overlapMinutes > 0}">
                            {{ (threeRateCoverage.percentage === 100 && threeRateCoverage.overlapMinutes === 0) ? '☑' : '⚠' }} Coverage: {{ threeRateCoverage.percentage }}%
                        </span>
                        <small *ngIf="threeRateCoverage.percentage < 100" class="text-danger ms-2">
                            ({{ threeRateCoverage.gapMinutes }} min / {{ (threeRateCoverage.gapMinutes / 60) | number:'1.0-1' }} hrs uncovered)
                        </small>
                        <small *ngIf="threeRateCoverage.overlapMinutes > 0" class="text-warning ms-2">
                            ({{ threeRateCoverage.overlapMinutes }} min / {{ (threeRateCoverage.overlapMinutes / 60) | number:'1.0-1' }} hrs overlapping)
                        </small>
                    </div>
                    <div class="coverage-boxes">
                        <div class="coverage-box weekday-color">
                            <div class="time-range">Weekday (Mon-Fri)</div>
                            <div class="time-period">{{ formatTime(assumptionForm.get('elecWeekdayStart')?.value) }} - {{ formatTime(assumptionForm.get('elecWeekdayEnd')?.value) }}</div>
                            <div class="rate">{{ assumptionForm.get('elecWeekdayRate')?.value || '-' }}p/kWh</div>
                        </div>
                        <div class="coverage-box evening-color">
                            <div class="time-range">Evening/Weekend</div>
                            <div class="time-period">{{ formatTime(assumptionForm.get('elecEveningStart')?.value) }} - {{ formatTime(assumptionForm.get('elecEveningEnd')?.value) }}</div>
                            <div class="rate">{{ assumptionForm.get('elecEveningRate')?.value || '-' }}p/kWh</div>
                        </div>
                        <div class="coverage-box night-color">
                            <div class="time-range">Night</div>
                            <div class="time-period">{{ formatTime(assumptionForm.get('elecEveningEnd')?.value) }} - {{ formatTime(assumptionForm.get('elecWeekdayStart')?.value) }}</div>
                            <div class="rate">{{ assumptionForm.get('elecNightRateThree')?.value || '-' }}p/kWh</div>
                        </div>
                        <div class="coverage-box gap-color" *ngFor="let gap of threeRateCoverage.gaps">
                            <div class="time-range">Gap</div>
                            <div class="time-period">{{ gap.start }} - {{ gap.end }}</div>
                            <div class="rate">No rate assigned</div>
                        </div>
                        <div class="coverage-box overlap-color" *ngFor="let overlap of threeRateCoverage.overlaps">
                            <div class="time-range">Overlap</div>
                            <div class="time-period">{{ overlap.start }} - {{ overlap.end }}</div>
                            <div class="rate">{{ overlap.periods }}</div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Two-Rate Configuration -->
            <ng-container *ngIf="assumptionForm.get('elecRateTypeMain')?.value === 'multi' && assumptionForm.get('elecRateTypeMulti')?.value === 'twoRate'">
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="form-label fs-14 text-muted">TWO RATE - EVENING/WEEKEND</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 mb-4">
                        <div class="form-group">
                            <label for="elecTwoWeekdayRate" class="form-label fs-15 mb-1">Weekday Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecTwoWeekdayRate" 
                                    placeholder="0" formControlName="elecTwoWeekdayRate" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="form-group">
                            <label for="elecTwoEveningRate" class="form-label fs-15 mb-1">Evening/Weekend/Night Rate</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecTwoEveningRate" 
                                    placeholder="0" formControlName="elecTwoEveningRate" step="0.01" />
                                <span class="input-group-text bg-white">p/kWh</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="form-group">
                            <label for="elecStandingChargeTwoRate" class="form-label fs-15 mb-1">Standing Charge</label>
                            <div class="input-group">
                                <input type="number" class="form-control inputTyp1" id="elecStandingChargeTwoRate" 
                                    placeholder="0" formControlName="elecStandingChargeTwoRate" step="0.01" />
                                <span class="input-group-text bg-white">p/day</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecTwoWeekdayStart" class="form-label fs-15 mb-1">Weekday Period Start</label>
                            <ngb-timepicker formControlName="elecTwoWeekdayStart" [spinners]="false"></ngb-timepicker>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="form-group">
                            <label for="elecTwoWeekdayEnd" class="form-label fs-15 mb-1">Weekday Period End</label>
                            <ngb-timepicker formControlName="elecTwoWeekdayEnd" [spinners]="false"></ngb-timepicker>
                        </div>
                    </div>
                </div>
                <div class="coverage-visualization">
                    <div class="coverage-header">
                        <span class="coverage-badge">☑ Coverage: 100%</span>
                    </div>
                    <div class="coverage-boxes">
                        <div class="coverage-box weekday-color">
                            <div class="time-range">Weekday (Mon-Fri)</div>
                            <div class="time-period">{{ formatTime(assumptionForm.get('elecTwoWeekdayStart')?.value) }} - {{ formatTime(assumptionForm.get('elecTwoWeekdayEnd')?.value) }}</div>
                            <div class="rate">{{ assumptionForm.get('elecTwoWeekdayRate')?.value || '-' }}p/kWh</div>
                        </div>
                        <div class="coverage-box evening-color">
                            <div class="time-range">Evening/Weekend/Night</div>
                            <div class="time-period">All other times</div>
                            <div class="rate">{{ assumptionForm.get('elecTwoEveningRate')?.value || '-' }}p/kWh</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </section>
        <hr *ngIf="source == 'edf'">

        <section *ngIf="source == 'edf'" aria-label="electricity-rate-config" class="mb-4">
            <div class="row">
                <div class="col-12">
                    <h3 class="fs-18 fw600 text-bodyGrey mb-3">Gas Rate Configuration</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="gasUnitRate" class="form-label fs-15 mb-1">Gas unit price (in p/kWh)</label>
                        <input type="text" class="form-control inputTyp1" id="gasUnitRate" placeholder="Gas unit price"
                            formControlName="gasUnitRate" />
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="gasStandingCharge" class="form-label fs-15 mb-1">Gas standing charge (in p/kWh)</label>
                        <input type="text" class="form-control inputTyp1" id="gasStandingCharge" placeholder="Gas standing charge"
                            formControlName="gasStandingCharge" />
                    </div>
                </div>
            </div>
        </section>
        <hr *ngIf="source == 'edf'">

        <section aria-label="gas-and-other-config" class="mt-4">
            <div class="row">
                <div *ngIf="source !== 'edf'" class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="elecUnitRate" class="form-label fs-15 mb-1">Electricity unit price (in p/kWh)</label>
                        <input type="text" class="form-control inputTyp1" id="elecUnitRate" placeholder="Electricity unit price"
                            formControlName="elecUnitRate" />
                    </div>
                </div>
                <div *ngIf="source !== 'edf'" class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="gasUnitRate" class="form-label fs-15 mb-1">Gas unit price (in p/kWh)</label>
                        <input type="text" class="form-control inputTyp1" id="gasUnitRate" placeholder="Gas unit price"
                            formControlName="gasUnitRate" />
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="area" class="form-label fs-15 mb-1">Heating source</label>
                        <ng-select class="form-ngselect" [searchable]="false" [clearable]="false"
                            placeholder="Select heating source" formControlName="heatingSource" required
                            aria-label="Default select example">
                            <ng-option value="Electricity">Electricity</ng-option>
                            <ng-option value="Gas">Gas</ng-option>
                            <ng-option value="Others">Others</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="area" class="form-label fs-15 mb-1">LED percentage</label>
                        <ngx-slider formControlName="ledPercent" [options]="options"></ngx-slider>
                    </div>
                </div>
            </div>
        </section>
        <section aria-label="electric-energy-split" class="mt-4">
            <div class="row">
                <div class="col-12">
                    <h3 class="fs-18 fw600 text-bodyGrey mb-3">Energy splits(Electric)</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="cateringElec" class="form-label">Cooking</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('cateringElec')?.value" formControlName="cateringElec" [options]="options"></ngx-slider>
                            <input min="0" max="100" [ngClass]="{'border-danger' : assumptionForm.get('cateringElec')?.invalid}" type="number" class="form-control inputTyp1 slider-input" id="cateringElec" placeholder="Lighting"
                                formControlName="cateringElec" [value]="assumptionForm.get('cateringElec')?.value" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="heatingElec" class="form-label">Heating</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('heatingElec')?.value" formControlName="heatingElec" [options]="options"></ngx-slider>
                            <input [value]="assumptionForm.get('heatingElec')?.value" min="0" max="100" [ngClass]="{'border-danger' : assumptionForm.get('heatingElec')?.invalid}" type="number" class="form-control inputTyp1 slider-input" id="heatingElec" placeholder="Lighting"
                            formControlName="heatingElec" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="hotwaterElec" class="form-label">Hot water</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('hotwaterElec')?.value" formControlName="hotwaterElec" [options]="options"></ngx-slider>
                            <input [value]="assumptionForm.get('hotwaterElec')?.value" min="0" max="100" [ngClass]="{'border-danger' : assumptionForm.get('hotwaterElec')?.invalid}" type="number" class="form-control inputTyp1 slider-input" id="hotwaterElec" placeholder="Lighting"
                                formControlName="hotwaterElec" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="lighting" class="form-label">Lighting</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('lighting')?.value" formControlName="lighting" [options]="options"></ngx-slider>
                            <input [value]="assumptionForm.get('lighting')?.value" min="0" max="100" [ngClass]="{'border-danger' : assumptionForm.get('lighting')?.invalid}" type="number" class="form-control inputTyp1 slider-input" id="lighting" placeholder="Lighting"
                                formControlName="lighting" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="others" class="form-label">Others</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('others')?.value" formControlName="others" [options]="options"></ngx-slider>
                            <input [value]="assumptionForm.get('others')?.value" min="0" max="100" [ngClass]="{'border-danger' : assumptionForm.get('others')?.invalid}"
                                type="number" class="form-control inputTyp1 slider-input" id="others" placeholder="others"
                                formControlName="others" />
                        </div>
                    </div>
                </div>
                <div class="col-12" *ngIf="elecErrorMessage">
                    <span class="text-danger">{{ elecErrorMessage }}</span>
                </div>
            </div>
        </section>
        <section aria-label="gas-energy-split" class="mt-4" *ngIf="assumptionData?.mprn?.length">
            <div class="row">
                <div class="col-12">
                    <h3 class="fs-18 fw600 text-bodyGrey mb-3">Energy splits(Gas)</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="cateringGas" class="form-label">Cooking</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('cateringGas')?.value" formControlName="cateringGas" [options]="options"></ngx-slider>
                            <input [value]="assumptionForm.get('cateringGas')?.value" min="0" max="100"
                                [ngClass]="{'border-danger' : assumptionForm.get('cateringGas')?.invalid}" type="number"
                                class="form-control inputTyp1 slider-input" id="cateringGas" placeholder="Lighting"
                                formControlName="cateringGas" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="heatingGas" class="form-label">Heating</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('heatingGas')?.value" formControlName="heatingGas" [options]="options"></ngx-slider>
                            <input [value]="assumptionForm.get('heatingGas')?.value" min="0" max="100" [ngClass]="{'border-danger' : assumptionForm.get('heatingGas')?.invalid}"
                                type="number" class="form-control inputTyp1 slider-input" id="heatingGas" placeholder="Lighting"
                                formControlName="heatingGas" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="form-group">
                        <label for="hotwaterGas" class="form-label">Hot water</label>
                        <div class="d-flex gap-3">
                            <ngx-slider [value]="assumptionForm.get('hotwaterGas')?.value" formControlName="hotwaterGas" [options]="options"></ngx-slider>
                            <input [value]="assumptionForm.get('hotwaterGas')?.value" min="0" max="100" [ngClass]="{'border-danger' : assumptionForm.get('hotwaterGas')?.invalid}"
                                type="number" class="form-control inputTyp1 slider-input" id="hotwaterGas" placeholder="Lighting"
                                formControlName="hotwaterGas" />
                        </div>
                    </div>
                </div>
                <div class="col-12" *ngIf="gasErrorMessage">
                    <span class="text-danger">{{ gasErrorMessage }}</span>
                </div>
            </div>
        </section>
    </form>
    <p *ngIf="successMessage" class="text-success"> {{ successMessage }} </p>
    <p *ngIf="errorMessage" class="text-danger">{{ errorMessage }}</p>
    <div class="mt-4 justify-content-lg-end d-grid d-lg-flex gap-3">
        <button type="button" class="btn-secondary" (click)="close()">
            Close
        </button>
        <button [disabled]="!assumptionForm.valid" class="btn-primary" type="button" (click)="updateAssumptions()">
            Update
        </button>
    </div>
</ng-container>